"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("../../shared/styles");
var _button = require("../../../forecast-v2/components/controls/buttons/button.tokens");
var _jsxRuntime = require("react/jsx-runtime");
var StyledButton = _styledComponents.default.button.withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-1vw6ufw-0"
})(["display:flex;justify-content:center;align-items:center;gap:", ";border-radius:", ";box-sizing:border-box;height:", ";", " background-color:", ";border:2px solid ", ";color:", ";cursor:pointer;&:hover{background-color:", ";border-color:", ";}&:active{background-color:", ";border-color:", ";}&:disabled{background-color:", ";border-color:", ";color:", ";svg{path{fill:", ";}}}&:focus-visible{", ";}svg{path{fill:", ";}}"], _styles.spacing.xs, _styles.borderRadius.s, function (_ref) {
  var size = _ref.size;
  return _styles.height[size];
}, function (_ref2) {
  var size = _ref2.size;
  return _styles.fonts.button[size];
}, function (props) {
  return _styles.colors.background[props.type].default;
}, function (props) {
  return _styles.colors.background[props.type].default;
}, function (props) {
  return _styles.button.type[props.type].textColor;
}, function (props) {
  return _styles.colors.background[props.type].hover;
}, function (props) {
  return _styles.colors.background[props.type].hover;
}, function (props) {
  return _styles.colors.background[props.type].active;
}, function (props) {
  return _styles.colors.background[props.type].active;
}, function (props) {
  return _styles.colors.background[props.type].disabled;
}, function (props) {
  return _styles.colors.background[props.type].disabled;
}, _styles.colors.text.disabled, _styles.colors.text.disabled, function (props) {
  return (0, _button.buttonTokens)(props.theme).focusRing.default;
}, function (props) {
  return _styles.button.type[props.type].textColor;
});
var Button = function Button(_ref3) {
  var children = _ref3.children,
    _onClick = _ref3.onClick,
    type = _ref3.type,
    size = _ref3.size,
    disabled = _ref3.disabled,
    otherButtonProps = _objectWithoutProperties(_ref3, ["children", "onClick", "type", "size", "disabled"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButton, _objectSpread({
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick(e);
    },
    type: type,
    size: size,
    disabled: disabled
  }, otherButtonProps, {
    children: children
  }));
};
exports.Button = Button;
Button.defaultProps = {
  type: 'pink',
  size: 'm',
  disabled: false,
  onClick: function onClick() {
    return void 0;
  }
};